import { render, staticRenderFns } from "./CtcProductVisual.vue?vue&type=template&id=2cd0e105&scoped=true&"
import script from "./CtcProductVisual.vue?vue&type=script&lang=js&"
export * from "./CtcProductVisual.vue?vue&type=script&lang=js&"
import style0 from "./CtcProductVisual.vue?vue&type=style&index=0&id=2cd0e105&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd0e105",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
